import { RefreshCw } from 'lucide-react';
import { useWebinarT } from '@/hooks/useWebinarT';
import { Button } from '@/components/ui/button';

export default function ErrorFallbackScreen({ onRetry }: Readonly<{ onRetry: () => void }>) {
  const { t } = useWebinarT('common');

  return (
    <div
      className="bg-gradient-page-auth h-svh w-full flex flex-col items-center justify-center overflow-hidden px-6"
      aria-live="assertive"
    >
      <div className="flex flex-col items-center gap-8 max-w-lg text-center">
        <div className="flex flex-col items-center gap-6">
          <img
            src="/assets/welya-splash.png"
            alt="Welya"
            className="w-32 h-32 object-contain opacity-90"
          />
        </div>

        <div className="space-y-3">
          <h2 className="text-xl font-semibold text-white">{t('errorFallback.title')}</h2>
        </div>

        <Button
          onClick={onRetry}
          className="bg-button-primary hover:bg-button-primary/90 text-dark font-semibold px-8 py-6 rounded-full gap-2 shadow-lg"
        >
          <RefreshCw className="size-5" />
          {t('errorFallback.retry')}
        </Button>
      </div>
    </div>
  );
}
